import useSWR from "swr";

import * as fetcher from "../fetcher";

interface PriceRange {
  minAmount: number;
  maxAmount: number;
}

export function usePriceRange() {
  return useSWR<PriceRange>(
    `/pricerange`,
    (url) => fetcher.opportunity.get(url),
    {
      keepPreviousData: true,
    }
  );
}
